import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Download, FileText, Scissors, Clock } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: FileText,
    text: 'Grandma & Me: Memory Tickets (fillable + print)'
  }, {
    icon: Scissors,
    text: '30 cut-out tickets (mixed ages 2–13)'
  }, {
    icon: Clock,
    text: 'First redemption page & Redemption tracker'
  }, {
    icon: Download,
    text: 'Quick instructions (7 minutes)'
  }];
  return <section ref={ref} className="py-20 px-4 md:px-6" data-id="element-241">
      <div className="max-w-4xl mx-auto" data-id="element-242">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-12 text-center" data-id="element-243">
          What you get (instant download)
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-244">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          delay: 0.1 * i
        }} className="flex items-center gap-4 p-6 bg-white rounded-xl shadow-sm border border-stone-100" data-id="element-245">
              <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center text-teal shrink-0" data-id="element-246">
                <item.icon className="w-6 h-6" data-id="element-247" />
              </div>
              <span className="text-charcoal font-medium text-lg" data-id="element-248">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}